import { css } from '@emotion/react'
import styled from '@emotion/styled'

const wrapperStyles = () => css`
  label: disclaimer;

  display: flex;
  flex-direction: column;
`

export const Wrapper = styled('div')(wrapperStyles)
